<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
        <div class="clearfix">
          <h4 class="pt-3">This is Logs Security Landing Page</h4>
        </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'FiduciaList',
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  async created(){
  }
}
</script>

<style>

</style>
